import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRecKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rec-keyframe, rhombus"><path fillRule="evenodd" clipRule="evenodd" d="M10.7624 2.42662C11.4458 1.74321 12.5539 1.74321 13.2373 2.42662L21.5731 10.7624C22.2565 11.4458 22.2565 12.5538 21.5731 13.2372L13.2373 21.5731C12.5539 22.2565 11.4458 22.2565 10.7624 21.5731L2.42662 13.2372C1.74321 12.5538 1.74321 11.4458 2.42663 10.7624L10.7624 2.42662ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12Z" fill="currentColor"/></CentralIconBase>;
};

export default IconRecKeyframe;
